import { type FC } from 'react';
import { isNotEmpty, useForm } from '@mantine/form';
import { Button, Group, Select, Stack, Textarea } from '@mantine/core';
import { useDeclinePayoutOrder } from '~/entities/payout';
import { DeclineReason } from './types';
import { declineReasons } from './constants';

export type DeclineOrderProps = {
    id: string;
    onCancel?: VoidFunction;
    onSuccess?: VoidFunction;
    onError?: (error: Error) => void;
};

export const DeclineOrder: FC<DeclineOrderProps> = ({ id, onCancel, onSuccess, onError }) => {
    const { mutate, isPending } = useDeclinePayoutOrder({ onSuccess, onError });

    const form = useForm({
        initialValues: {
            orderId: {
                value: id,
            },
            declineReason: DeclineReason.DECLINE_REASON_BROKEN_REQUISITES,
            comment: '',
        },
        validate: {
            comment: isNotEmpty('Комментарий обязателен к заполнению'),
        },
    });

    return (
        <form
            onSubmit={form.onSubmit((values) => {
                mutate(values);
            })}
        >
            <Stack miw={300}>
                <Select
                    label='Причина отказа'
                    data={declineReasons}
                    {...form.getInputProps('declineReason')}
                />

                <Textarea
                    label='Комментарий'
                    {...form.getInputProps('comment')}
                />

                <Group justify='flex-end'>
                    <Button
                        title='Подтвердить отклонение'
                        color='red'
                        disabled={isPending}
                        loading={isPending}
                        type='submit'
                    >
                        Подтвердить отклонение
                    </Button>

                    {onCancel && (
                        <Button
                            title='Отмена'
                            disabled={isPending}
                            onClick={onCancel}
                        >
                            Отмена
                        </Button>
                    )}
                </Group>
            </Stack>
        </form>
    );
};
